import {match, Pattern} from 'ts-pattern';

import type {
  CustomerInsightsHistoryGroup,
  CustomerInsightsRecord,
} from '../types/CustomerInsightsViewModel';
import {sortCustomerInsightsRecordsByOccurredAt} from './sortCustomerInsightsRecordsByOccurredAt';

export const CUSTOMER_INSIGHTS_HISTORY_LIMIT = 5;

export function takeNewestHistory(
  records: CustomerInsightsRecord[],
  total: number | undefined,
  limit = CUSTOMER_INSIGHTS_HISTORY_LIMIT
): CustomerInsightsHistoryGroup {
  return {
    ...match(total)
      .with(Pattern.number, (value) => ({total: value}))
      .otherwise(() => ({})),
    items: sortCustomerInsightsRecordsByOccurredAt(records).slice(0, limit),
  };
}
